export default __webpack_public_path__ + "static/media/kbt.62cfbe2b.jpg";